<script>
    import { Route, Router, router, navigateTo } from 'yrv'
    import Ztab from '../_common/z/ztab.svelte'
    import Financial_4Home from './home/financial-4-home.svelte'
    import Financial_4Pos from './accounts-pos/financial-4-pos.svelte'
    import Financial_4BillsToPay from './bills/financial-4-bills-to-pay.svelte'
    import Financial_4Accounts from './accounts/financial-4-accounts.svelte'
    import Financial_4BillsToReceive from './bills/financial-4-bills-to-receive.svelte'
    import Financial_4RelatResult from './result/financial-4-relat-result.svelte'
    import { onMount } from 'svelte'
    import Financial_4Report from './report/financial-4-report.svelte'
    import { canFinancialTab, financialHome, financialTabs } from '../../modules/infra/permissions'

    // cada aba tem a sua permissão (financial.tabs.*)
    let tabs = [...financialTabs.filter((tab) => canFinancialTab(tab.path)).map(({ title, url }) => ({ title, url })), { spacer: true }]

    const home = financialHome()

    // /results é a mesma tela do início
    const guardedUrls = [...financialTabs, { url: '/financial-4/results', path: 'financial.tabs.home' }]

    // aba bloqueada (link antigo, menu, URL digitada) cai na primeira liberada — o início pode estar bloqueado
    $: {
        $router
        // ao sair do financeiro o router avisa antes deste componente ser destruído: não pode puxar de volta
        if (location.pathname.startsWith('/financial-4')) {
            const tab = guardedUrls.find((el) => location.pathname.startsWith(el.url))
            if (home && (!tab || !canFinancialTab(tab.path))) navigateTo(home, { replace: true })
        }
    }

    onMount(async () => {})
</script>

<div class="root-content">
    <Ztab {tabs} class="h-space" />
    {#if !home}
        <div class="mt-3 text-muted">Nenhuma aba do Financeiro está liberada para o seu usuário.</div>
    {/if}
    <Router>
        {#if canFinancialTab('financial.tabs.home')}
            <Route path="/home">
                <!-- <Financial_4Home></Financial_4Home> -->
                <Financial_4RelatResult></Financial_4RelatResult>
            </Route>
            <Route path="/results">
                <Financial_4RelatResult></Financial_4RelatResult>
            </Route>
        {/if}
        {#if canFinancialTab('financial.tabs.billsToPay')}
            <Route path="/bills-to-pay">
                <Financial_4BillsToPay></Financial_4BillsToPay>
            </Route>
        {/if}
        {#if canFinancialTab('financial.tabs.billsToReceive')}
            <Route path="/bills-to-receive">
                <Financial_4BillsToReceive></Financial_4BillsToReceive>
            </Route>
        {/if}
        {#if canFinancialTab('financial.tabs.pos')}
            <Route path="/pos">
                <Financial_4Pos></Financial_4Pos>
            </Route>
        {/if}
        {#if canFinancialTab('financial.tabs.accounts')}
            <Route path="/accounts">
                <Financial_4Accounts></Financial_4Accounts>
            </Route>
        {/if}
        {#if canFinancialTab('financial.tabs.reports')}
            <Route path="/reports">
                <Financial_4Report></Financial_4Report>
            </Route>
        {/if}
    </Router>
</div>
